// extracted by mini-css-extract-plugin
export default {"choose-switch__switch":"_bz94","chooseSwitch__switch":"_bz94","appear-from-above":"vD_Sd","appearFromAbove":"vD_Sd"};